function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pizzaIcon_svg__clip0_570_13193)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.406 4.098S12.48 3.742 17.4 6.46c4.918 2.718 6.842 6.12 6.842 6.12s.196.812-.444 1.177c-.715.408-1.135.07-1.135.07s-2.492-3.404-6.298-5.507C12.56 6.218 8.19 6.23 8.19 6.23s-.127-.173-.315-1.015c.15-.93.531-1.116.531-1.116z",
  fill: "#F6E6B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.406 4.098S12.48 3.742 17.4 6.46c4.918 2.718 6.842 6.12 6.842 6.12s.196.812-.444 1.177c-.715.408-1.135.07-1.135.07s-2.492-3.404-6.298-5.507C12.56 6.218 8.19 6.23 8.19 6.23s-.127-.173-.315-1.015c.15-.93.531-1.116.531-1.116z",
  stroke: "#834B21",
  strokeWidth: 0.824,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.306 4.833s4.245.054 8.548 2.432c4.304 2.38 6.756 6.118 6.756 6.118l-.377.327-.56.012s-3.014-3.867-6.34-5.705c-3.33-1.84-8.007-2.036-8.007-2.036l-.174-.607.154-.541z",
  fill: "#FFB36B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.129 23.269l.05-.664.141-1.899L8.403 6.235s4.479.151 7.969 2.08c3.49 1.927 5.992 5.632 5.992 5.632L9.763 22.849l-1.13.799-.36.253-1.144-.632z",
  fill: "#F83824"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.129 23.269l.05-.664.141-1.899L8.403 6.235s4.479.151 7.969 2.08c3.49 1.927 5.992 5.632 5.992 5.632L9.763 22.849l-1.13.799-.36.253-1.144-.632z",
  stroke: "#834B21",
  strokeWidth: 0.824,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.101 23.253L8.198 8.967s4.53-2.598 8.173-.652c3.644 1.946 3.728 7.208 3.728 7.208L8.288 23.908l-1.187-.655z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.101 23.253L8.198 8.967s4.53-2.598 8.173-.652c3.644 1.946 3.728 7.208 3.728 7.208L8.288 23.908l-1.187-.655z",
  stroke: "#834B21",
  strokeWidth: 0.824,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.767 23.326L8.769 9.611S12.808 7.38 16 9.145c3.188 1.761 3.276 6.647 3.276 6.647L8.29 23.61l-.523-.284z",
  fill: "#F6E6B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.646 22.498l.497.303 1.044-.707s2.946-4.18 4.17-4.353c1.22-.175 3.491-.824 3.505-1.874.014-1.056-2.071-2.943-3.434-1.66-1.358 1.29-3.63 4.988-4.447 4.726-.818-.262-.506-4.67.053-5.172.563-.495 2.65-2.606 2.11-3.278-.543-.678-2.389.159-2.389.159l-1.11 11.856z",
  fill: "#FFB36B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.047 12.386c-.474-.746.07-2.024 1.479-1.98 1.407.05 2.591.994 2.524 2.914-.07 1.925.434 3.084.434 3.084l-1.567.998s.528-3.306.07-4.118c-.458-.812-2.474-.15-2.94-.898z",
  fill: "#FFB36B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.98 16.65a1.857 1.857 0 01-.636-2.55 1.868 1.868 0 012.558-.639 1.857 1.857 0 01.636 2.552 1.868 1.868 0 01-2.557.637z",
  fill: "#E2475A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.98 16.65a1.857 1.857 0 01-.636-2.55 1.868 1.868 0 012.558-.639 1.857 1.857 0 01.636 2.552 1.868 1.868 0 01-2.557.637z",
  stroke: "#834B21",
  strokeWidth: 0.824
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.922 13.808c-.414-.446-1.65-.59-2.28.321a1.59 1.59 0 00.64 2.38c.289-.479-.95-1.196-.282-2.16.668-.963 1.658-.103 1.922-.54zM15.986 16.012a.265.265 0 01-.09-.364.267.267 0 01.364-.09.265.265 0 01.091.363.267.267 0 01-.365.091z",
  fill: "#ED8E9A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.347 15.01a.265.265 0 01-.09-.364.265.265 0 11.09.364zM16.535 15.102a.265.265 0 01-.091-.364.267.267 0 01.365-.091.265.265 0 01.091.364.267.267 0 01-.365.091z",
  fill: "#ED8E9A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.187 13.397a1.857 1.857 0 01-.636-2.551 1.868 1.868 0 012.558-.638 1.857 1.857 0 01.636 2.551 1.868 1.868 0 01-2.558.638z",
  fill: "#E2475A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.187 13.397a1.857 1.857 0 01-.636-2.551 1.868 1.868 0 012.558-.638 1.857 1.857 0 01.636 2.551 1.868 1.868 0 01-2.558.638z",
  stroke: "#834B21",
  strokeWidth: 0.824
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.129 10.555c-.415-.447-1.65-.591-2.28.32a1.59 1.59 0 00.64 2.38c.288-.478-.95-1.195-.282-2.159.667-.964 1.658-.104 1.921-.541zM11.193 12.76a.265.265 0 01-.091-.365.267.267 0 01.365-.091.265.265 0 01.09.364.267.267 0 01-.364.091z",
  fill: "#ED8E9A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.554 11.757a.265.265 0 01-.091-.365.267.267 0 01.365-.09.265.265 0 01.091.364.267.267 0 01-.365.09zM11.741 11.849a.265.265 0 01-.09-.365.267.267 0 01.365-.09.265.265 0 01.09.364.267.267 0 01-.365.09z",
  fill: "#ED8E9A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.254 18.742a1.857 1.857 0 01-.636-2.551 1.868 1.868 0 012.557-.638 1.857 1.857 0 01.637 2.551 1.868 1.868 0 01-2.558.638z",
  fill: "#E2475A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.254 18.742a1.857 1.857 0 01-.636-2.551 1.868 1.868 0 012.557-.638 1.857 1.857 0 01.637 2.551 1.868 1.868 0 01-2.558.638z",
  stroke: "#834B21",
  strokeWidth: 0.824
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.195 15.9c-.414-.446-1.649-.591-2.28.32a1.59 1.59 0 00.64 2.38c.289-.478-.95-1.195-.281-2.159.667-.964 1.658-.104 1.921-.541zM11.26 18.104a.265.265 0 01-.092-.364.267.267 0 01.366-.091.265.265 0 01.09.364.267.267 0 01-.365.091z",
  fill: "#ED8E9A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.62 17.102a.265.265 0 01-.09-.365.265.265 0 11.456.273.267.267 0 01-.365.092zM11.808 17.194a.265.265 0 01-.09-.365.265.265 0 11.456.273.267.267 0 01-.366.092z",
  fill: "#ED8E9A"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pizzaIcon_svg__clip0_570_13193"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})));
function SvgPizzaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgPizzaIcon;